import spacing from "../spacing";
import breakpoints from "../breakpoints";

export default {
  root: {
    padding: spacing(2),
    [breakpoints.down("sm")]: {
      padding: spacing(1)
    }
  }
};
